<template>
  <div>
    <Subtitle :subtitle="rightObj.subTitle" style="height: 14%; padding-top: 1%" />
    <div class="boxMain" style="height: 83%">
      <div class="rateBox">
        <div class="rateItem" @click="onRateItemClick(1)">
          <div
            v-if="myOption01.series"
            class="charts"
            ref="myChart01"
            :parmas="myOption01"
          ></div>
          <dv-loading v-else>Loading...</dv-loading>
        </div>
        <div class="rateItem" @click="onRateItemClick(2)">
          <div
            v-if="myOption02.series"
            class="charts"
            ref="myChart02"
            :parmas="myOption02"
          ></div>
          <dv-loading v-else>Loading...</dv-loading>
        </div>
        <div class="rateItem" @click="onRateItemClick(3)">
          <div
            v-if="myOption03.series"
            class="charts"
            ref="myChart03"
            :parmas="myOption03"
          ></div>
          <dv-loading v-else>Loading...</dv-loading>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import Subtitle from "@/components/header/subTitle.vue";
export default {
  props: {
    rightObj: {
      typeof: Object,
    },
  },
  components: {
    Subtitle,
  },
  data() {
    return {
      myOption01: {},
      myOption02: {},
      myOption03: {},
      totalNum: 0,
      onLineNum: 0,
      offLineNum: 0,
    };
  },
  computed: {},
  watch: {
    totalNum: {
      deep: true, //开启监听模式
      handler() {
        this.initChartsTotal();
      },
      immediate: true,
    },
    onLineNum: {
      deep: true, //开启监听模式
      handler() {
        this.initChartsOnLine();
      },
      immediate: true,
    },
    offLineNum: {
      deep: true, //开启监听模式
      handler() {
        this.initChartsOffLine();
      },
      immediate: true,
    },
    rightObj: {
      deep: true, //开启监听模式
      handler() {
        this.totalNum = this.rightObj.totalNum;
        this.onLineNum = this.rightObj.onLineNum;
        this.offLineNum = this.rightObj.offLineNum;
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {
    this.totalNum = this.rightObj.totalNum;
    this.onLineNum = this.rightObj.onLineNum;
    this.offLineNum = this.rightObj.offLineNum;
  },
  destroyed() {
    clearInterval(this.intervalTime01);
    clearInterval(this.intervalTime02);
    clearInterval(this.intervalTime03);
  },
  methods: {
    initChartsTotal() {
      let myChart01;
      this.$nextTick(() => {
        let angle = 0; // 角度
        let dataValue = this.rightObj.totalNum;
        this.myOption01 = {
          backgroundColor: null,
          title: {
            text: `{v|${dataValue}}{unit|}\n{t|总数}`,
            x: "center",
            y: "center",
            textStyle: {
              rich: {
                v: { fontSize: 22, color: "#fff" },
                unit: { fontSize: 12, color: "#fff" },
                t: { fontSize: 14, color: "#fff" },
              },
            },
          },
          series: [
            /** 绘制内部圆弧-1 <right-top> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                return {
                  type: "arc",
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.6,
                    startAngle: ((270 + angle) * Math.PI) / 180,
                    endAngle: ((360 + angle) * Math.PI) / 180,
                  },
                  style: {
                    fill: "transparent",
                    stroke: "rgba(1, 248, 68, 0.4)",
                    lineWidth: 2,
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 绘制内部圆弧-2 <left-bottom> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                return {
                  type: "arc",
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.6,
                    startAngle: ((90 + angle) * Math.PI) / 180,
                    endAngle: ((180 + angle) * Math.PI) / 180,
                  },
                  style: {
                    fill: "transparent",
                    stroke: "rgba(1, 248, 68, 0.4)",
                    lineWidth: 2,
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 绘制外部圆弧-1 <right-bottom> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                return {
                  type: "arc",
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.66,
                    startAngle: ((355 + -angle) * Math.PI) / 180,
                    endAngle: ((120 + -angle) * Math.PI) / 180,
                  },
                  style: {
                    fill: "transparent",
                    stroke: "rgba(1, 248, 68, 0.4)",
                    lineWidth: 2.6,
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 绘制外部圆弧-2 <left-top> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                return {
                  type: "arc",
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.66,
                    startAngle: ((175 + -angle) * Math.PI) / 180,
                    endAngle: ((300 + -angle) * Math.PI) / 180,
                  },
                  style: {
                    fill: "transparent",
                    stroke: "rgba(1, 248, 68, 0.4)",
                    lineWidth: 2.6,
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 绘制外部圆弧-1-开始圆点 <right-bottom> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                let x0 = api.getWidth() / 2;
                let y0 = api.getHeight() / 2;
                let r = (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.66;
                return {
                  type: "circle",
                  shape: {
                    /** 角度355° 外弧1开始角度 */
                    cx: x0 + r * Math.cos(((355 + -angle) * Math.PI) / 180),
                    cy: y0 + r * Math.sin(((355 + -angle) * Math.PI) / 180),
                    r: 4,
                  },
                  style: {
                    fill: "rgba(1, 248, 68, 0.4)",
                    stroke: "rgba(1, 248, 68, 0.4)",
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 绘制外部圆弧-2-开始圆点 <left-top> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                let x0 = api.getWidth() / 2;
                let y0 = api.getHeight() / 2;
                let r = (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.66;
                return {
                  type: "circle",
                  shape: {
                    /** 角度175° 外弧2开始角度 */
                    cx: x0 + r * Math.cos(((175 + -angle) * Math.PI) / 180),
                    cy: y0 + r * Math.sin(((175 + -angle) * Math.PI) / 180),
                    r: 4,
                  },
                  style: {
                    fill: "rgba(1, 248, 68, 0.4)",
                    stroke: "rgba(1, 248, 68, 0.4)",
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 刻度仪表盘 */
            {
              type: "gauge",
              center: ["50%", "50%"],
              radius: "68.5%", // 错位调整此处
              startAngle: 0,
              endAngle: 360,
              axisLine: { show: false },
              splitLine: { show: false },
              axisTick: {
                splitNumber: 10,
                // length: 8,  // 刻度长度
                length: "4%",
                lineStyle: {
                  color: "rgba(1, 248, 68, 0.4)",
                  width: 1.5,
                },
              },
              axisLabel: { show: false },
            },
            /** 内心圆 */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                return {
                  type: "circle",
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.38,
                    startAngle: ((175 + angle) * Math.PI) / 180,
                    endAngle: ((300 + angle) * Math.PI) / 180,
                  },
                  style: {
                    fill: "transparent",
                    stroke: "#00374C80",
                    lineWidth: 2.6,
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 饼图 */
            {
              name: "正",
              type: "pie",
              startAngle: 90,
              z: 0,
              label: {
                position: "center",
              },
              radius: ["56%", "44%"],
              silent: true,
              animation: false, // 关闭饼图动画
              data: [
                {
                  value: 100,
                  itemStyle: {
                    color: {
                      type: "linear",
                      x: 0,
                      y: 0.2,
                      x2: 1,
                      y2: 0,
                      colorStops: [
                        { offset: 0, color: "#01f74420" },
                        { offset: 1, color: "#01f744" },
                      ],
                    },
                  },
                },
                {
                  name: "反",
                  value: 0,
                  label: { show: false },
                  itemStyle: { color: "#00374C" },
                },
              ],
            },
            /** 饼图上刻度 */
            {
              type: "gauge",
              center: ["50%", "50%"],
              radius: "63%", // 错位调整此处
              startAngle: 0,
              endAngle: 360,
              splitNumber: 12,
              axisLine: { show: false },
              splitLine: {
                length: "24%",
                lineStyle: {
                  width: 10,
                  color: "#002837",
                },
              },
              axisTick: { show: false },
              axisLabel: { show: false },
            },
          ],
        };
        clearInterval(this.intervalTime01);
        this.intervalTime01 = setInterval(() => {
          angle = angle + 2;
          if (this.$refs.myChart01) {
            //echarts.dispose(this.$refs.myChart01)
            myChart01 = myChart01 || echarts.init(this.$refs.myChart01);
            myChart01.setOption(this.myOption01, true);
          }
        }, 80);
      });
    },
    initChartsOnLine() {
      let myChart02;
      this.$nextTick(() => {
        let angle = 0; // 角度
        let onLineNum = this.rightObj.onLineNum || 0;
        let totalNum = this.rightObj.totalNum || 0;
        let dataValue = ((onLineNum / totalNum) * 100).toFixed(0);
        this.myOption02 = {
          backgroundColor: null,
          title: {
            text: `{v|${onLineNum}}{unit|}\n{t|今日飞行数}`,
            x: "center",
            y: "center",
            textStyle: {
              rich: {
                v: { fontSize: 22, color: "#fff" },
                unit: { fontSize: 12, color: "#fff" },
                t: { fontSize: 12, color: "#fff" },
              },
            },
          },
          series: [
            /** 绘制内部圆弧-1 <right-top> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                return {
                  type: "arc",
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.6,
                    startAngle: ((270 + angle) * Math.PI) / 180,
                    endAngle: ((360 + angle) * Math.PI) / 180,
                  },
                  style: {
                    fill: "transparent",
                    stroke: "rgba(19,153,254, 0.4)",
                    lineWidth: 2,
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 绘制内部圆弧-2 <left-bottom> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                return {
                  type: "arc",
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.6,
                    startAngle: ((90 + angle) * Math.PI) / 180,
                    endAngle: ((180 + angle) * Math.PI) / 180,
                  },
                  style: {
                    fill: "transparent",
                    stroke: "rgba(19,153,254, 0.4)",
                    lineWidth: 2,
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 绘制外部圆弧-1 <right-bottom> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                return {
                  type: "arc",
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.66,
                    startAngle: ((355 + -angle) * Math.PI) / 180,
                    endAngle: ((120 + -angle) * Math.PI) / 180,
                  },
                  style: {
                    fill: "transparent",
                    stroke: "rgba(19,153,254, 0.4)",
                    lineWidth: 2.6,
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 绘制外部圆弧-2 <left-top> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                return {
                  type: "arc",
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.66,
                    startAngle: ((175 + -angle) * Math.PI) / 180,
                    endAngle: ((300 + -angle) * Math.PI) / 180,
                  },
                  style: {
                    fill: "transparent",
                    stroke: "rgba(19,153,254, 0.4)",
                    lineWidth: 2.6,
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 绘制外部圆弧-1-开始圆点 <right-bottom> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                let x0 = api.getWidth() / 2;
                let y0 = api.getHeight() / 2;
                let r = (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.66;
                return {
                  type: "circle",
                  shape: {
                    /** 角度355° 外弧1开始角度 */
                    cx: x0 + r * Math.cos(((355 + -angle) * Math.PI) / 180),
                    cy: y0 + r * Math.sin(((355 + -angle) * Math.PI) / 180),
                    r: 4,
                  },
                  style: {
                    fill: "rgba(19,153,254, 0.4)",
                    stroke: "rgba(19,153,254, 0.4)",
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 绘制外部圆弧-2-开始圆点 <left-top> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                let x0 = api.getWidth() / 2;
                let y0 = api.getHeight() / 2;
                let r = (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.66;
                return {
                  type: "circle",
                  shape: {
                    /** 角度175° 外弧2开始角度 */
                    cx: x0 + r * Math.cos(((175 + -angle) * Math.PI) / 180),
                    cy: y0 + r * Math.sin(((175 + -angle) * Math.PI) / 180),
                    r: 4,
                  },
                  style: {
                    fill: "rgba(19,153,254, 0.4)",
                    stroke: "rgba(19,153,254, 0.4)",
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 刻度仪表盘 */
            {
              type: "gauge",
              center: ["50%", "50%"],
              radius: "68.5%", // 错位调整此处
              startAngle: 0,
              endAngle: 360,
              axisLine: { show: false },
              splitLine: { show: false },
              axisTick: {
                splitNumber: 10,
                length: "4%",
                lineStyle: {
                  color: "rgba(19,153,254, 0.4)",
                  width: 1.5,
                },
              },
              axisLabel: { show: false },
            },
            /** 内心圆 */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                return {
                  type: "circle",
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.38,
                    startAngle: ((175 + angle) * Math.PI) / 180,
                    endAngle: ((300 + angle) * Math.PI) / 180,
                  },
                  style: {
                    fill: "transparent",
                    stroke: "#00374C80",
                    lineWidth: 2.6,
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 饼图 */
            {
              name: "正",
              type: "pie",
              startAngle: 90,
              z: 0,
              label: {
                position: "center",
              },
              radius: ["56%", "44%"],
              silent: true,
              animation: false, // 关闭饼图动画
              data: [
                {
                  value: dataValue,
                  itemStyle: {
                    color: {
                      type: "linear",
                      x: 0,
                      y: 0.2,
                      x2: 1,
                      y2: 0,
                      colorStops: [
                        { offset: 0, color: "#149BFD20" },
                        { offset: 1, color: "#149BFD" },
                      ],
                    },
                  },
                },
                {
                  name: "反",
                  value: 100 - dataValue,
                  label: { show: false },
                  itemStyle: { color: "#00374C" },
                },
              ],
            },
            /** 饼图上刻度 */
            {
              type: "gauge",
              center: ["50%", "50%"],
              radius: "63%", // 错位调整此处
              startAngle: 0,
              endAngle: 360,
              splitNumber: 12,
              axisLine: { show: false },
              splitLine: {
                length: "24%",
                lineStyle: {
                  width: 10,
                  color: "#002837",
                },
              },
              axisTick: { show: false },
              axisLabel: { show: false },
            },
          ],
        };
        clearInterval(this.intervalTime02);
        this.intervalTime02 = setInterval(() => {
          angle = angle + 2;
          if (this.$refs.myChart02) {
            //echarts.dispose(this.$refs.myChart02)
            myChart02 = myChart02 || echarts.init(this.$refs.myChart02);
            myChart02.setOption(this.myOption02, true);
          }
        }, 80);
      });
    },
    initChartsOffLine() {
      let myChart03;
      this.$nextTick(() => {
        let angle = 0; // 角度
        let offLineNum = this.rightObj.offLineNum;
        let totalNum = this.rightObj.totalNum || 0;
        let dataValue = ((offLineNum / totalNum) * 100).toFixed(0);
        this.myOption03 = {
          backgroundColor: null,
          title: {
            text: `{v|${offLineNum}}{unit|}\n{t|在线数}`,
            x: "center",
            y: "center",
            textStyle: {
              rich: {
                v: { fontSize: 22, color: "#fff" },
                unit: { fontSize: 12, color: "#fff" },
                t: { fontSize: 14, color: "#fff" },
              },
            },
          },
          series: [
            /** 绘制内部圆弧-1 <right-top> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                return {
                  type: "arc",
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.6,
                    startAngle: ((270 + angle) * Math.PI) / 180,
                    endAngle: ((360 + angle) * Math.PI) / 180,
                  },
                  style: {
                    fill: "transparent",
                    stroke: "rgba(250,197,57, 0.4)",
                    lineWidth: 2,
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 绘制内部圆弧-2 <left-bottom> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                return {
                  type: "arc",
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.6,
                    startAngle: ((90 + angle) * Math.PI) / 180,
                    endAngle: ((180 + angle) * Math.PI) / 180,
                  },
                  style: {
                    fill: "transparent",
                    stroke: "rgba(250,197,57, 0.4)",
                    lineWidth: 2,
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 绘制外部圆弧-1 <right-bottom> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                return {
                  type: "arc",
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.66,
                    startAngle: ((355 + -angle) * Math.PI) / 180,
                    endAngle: ((120 + -angle) * Math.PI) / 180,
                  },
                  style: {
                    fill: "transparent",
                    stroke: "rgba(250,197,57, 0.4)",
                    lineWidth: 2.6,
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 绘制外部圆弧-2 <left-top> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                return {
                  type: "arc",
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.66,
                    startAngle: ((175 + -angle) * Math.PI) / 180,
                    endAngle: ((300 + -angle) * Math.PI) / 180,
                  },
                  style: {
                    fill: "transparent",
                    stroke: "rgba(250,197,57, 0.4)",
                    lineWidth: 2.6,
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 绘制外部圆弧-1-开始圆点 <right-bottom> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                let x0 = api.getWidth() / 2;
                let y0 = api.getHeight() / 2;
                let r = (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.66;
                return {
                  type: "circle",
                  shape: {
                    /** 角度355° 外弧1开始角度 */
                    cx: x0 + r * Math.cos(((355 + -angle) * Math.PI) / 180),
                    cy: y0 + r * Math.sin(((355 + -angle) * Math.PI) / 180),
                    r: 4,
                  },
                  style: {
                    fill: "rgba(250,197,57, 0.4)",
                    stroke: "rgba(250,197,57, 0.4)",
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 绘制外部圆弧-2-开始圆点 <left-top> */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                let x0 = api.getWidth() / 2;
                let y0 = api.getHeight() / 2;
                let r = (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.66;
                return {
                  type: "circle",
                  shape: {
                    /** 角度175° 外弧2开始角度 */
                    cx: x0 + r * Math.cos(((175 + -angle) * Math.PI) / 180),
                    cy: y0 + r * Math.sin(((175 + -angle) * Math.PI) / 180),
                    r: 4,
                  },
                  style: {
                    fill: "rgba(250,197,57, 0.4)",
                    stroke: "rgba(250,197,57, 0.4)",
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 刻度仪表盘 */
            {
              type: "gauge",
              center: ["50%", "50%"],
              radius: "68.5%", // 错位调整此处
              startAngle: 0,
              endAngle: 360,
              axisLine: { show: false },
              splitLine: { show: false },
              axisTick: {
                splitNumber: 10,
                // length: 8,  // 刻度长度
                length: "4%",
                lineStyle: {
                  color: "rgba(250,197,57, 0.4)",
                  width: 1.5,
                },
              },
              axisLabel: { show: false },
            },
            /** 内心圆 */
            {
              type: "custom",
              coordinateSystem: "none",
              renderItem: (params, api) => {
                return {
                  type: "circle",
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.38,
                    startAngle: ((175 + angle) * Math.PI) / 180,
                    endAngle: ((300 + angle) * Math.PI) / 180,
                  },
                  style: {
                    fill: "transparent",
                    stroke: "#00374C80",
                    lineWidth: 2.6,
                  },
                  silent: true,
                };
              },
              data: [0],
            },
            /** 饼图 */
            {
              name: "正",
              type: "pie",
              startAngle: 90,
              z: 0,
              label: {
                position: "center",
              },
              radius: ["56%", "44%"],
              silent: true,
              animation: false, // 关闭饼图动画
              data: [
                {
                  value: dataValue,
                  itemStyle: {
                    color: {
                      type: "linear",
                      x: 0,
                      y: 0.2,
                      x2: 1,
                      y2: 0,
                      colorStops: [
                        { offset: 0, color: "#e3b33720" },
                        { offset: 1, color: "#e3b337" },
                      ],
                    },
                  },
                },
                {
                  name: "反",
                  value: 100 - dataValue,
                  label: { show: false },
                  itemStyle: { color: "#e3b33720" },
                },
              ],
            },
            /** 饼图上刻度 */
            {
              type: "gauge",
              center: ["50%", "50%"],
              radius: "63%", // 错位调整此处
              startAngle: 0,
              endAngle: 360,
              splitNumber: 12,
              axisLine: { show: false },
              splitLine: {
                // length: 39,
                length: "24%",
                lineStyle: {
                  width: 10,
                  color: "#002837",
                },
              },
              axisTick: { show: false },
              axisLabel: { show: false },
            },
          ],
        };
        clearInterval(this.intervalTime03);
        this.intervalTime03 = setInterval(() => {
          angle = angle + 2;
          if (this.$refs.myChart03) {
            //echarts.dispose(this.$refs.myChart03)
            myChart03 = myChart03 || echarts.init(this.$refs.myChart03);
            myChart03.setOption(this.myOption03, true);
          }
        }, 80);
      });
    },
    onRateItemClick(value) {
      this.$emit("childNumberClick", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.boxMain {
  display: flex;
  align-items: center;
  justify-content: center;
  .rateBox {
    width: 100%;
    height: 125px;
    display: flex;
    justify-content: space-evenly;
    .rateItem {
      width: 125px;
      height: 125px;
      position: relative;
      .charts {
        width: 128%;
        height: 128%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>
